import { useEffect, useState } from 'react';
import { useBackdropContext } from '../../../../../context/backdrop';
import { millisecondsToSeconds } from '../../../../../utils/helpers';
import { useBlindCalibrateManually } from '../../../api/blind/blind.hooks';
import { useChannelsStateStore } from '../../../store/channels-state';
import { ChannelCoverStateType, ChannelType } from '../../../types';

export const useBlindManualCalibration = (
  channel: ChannelType,
  setShowManualDialog: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const [openTimeTemp, setOpenTimeTemp] = useState<string>('0');
  const [closeTimeTemp, setCloseTimeTemp] = useState<string>('0');

  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const setBlindManually = useBlindCalibrateManually();
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelCoverStateType | null;
  const calibrateState = state?.calibrateState;

  useEffect(() => {
    if (calibrateState?.openingMilliseconds) {
      setOpenTimeTemp(millisecondsToSeconds(calibrateState.openingMilliseconds).toString());
    }

    if (calibrateState?.closingMilliseconds) {
      setCloseTimeTemp(millisecondsToSeconds(calibrateState.closingMilliseconds).toString());
    }
  }, [calibrateState?.openingMilliseconds, calibrateState?.closingMilliseconds]);

  const saveManualCalibrationParams = () => {
    turnOnBackdrop();

    setBlindManually.mutate(
      {
        channelId: channel.id,
        openingMs: Number(openTimeTemp) * 1000,
        closingMs: Number(closeTimeTemp) * 1000,
        deviceId: channel.deviceId,
      },
      {
        onSuccess: () => {
          setShowManualDialog(false);
          turnOffBackdrop();
        },
      },
    );
  };

  return {
    openTimeTemp,
    closeTimeTemp,
    setOpenTimeTemp,
    setCloseTimeTemp,
    saveManualCalibrationParams,
    calibrateState,
  };
};
